"use strict";

export default class MyPanelController 
{
	/*@ngInject*/
	constructor($log, $http, ValidationService, Modal)
	{
		//this.getCurrentUser = Auth.getCurrentUser;
		this.$http = $http;
		this.validation = new ValidationService();
		//this.validation.setGlobalOptions({hideErrorUnderInputs: false});
		this.Modal = Modal;

		this.transponder = null;
		this.comments = null;
		
		this.currentPage = 1;
		this.pageSize = 6;
		this.PageChanged();
		
		$http.post("/api/frontend/mypanel")
		.then(response => {
			this.user = response.data;
		});

		this.LoadTransponders();
	}

	LoadTransponders()
	{
		this.$http.post("/api/frontend/mypanel/transponderlist")
		.then(response => {
			this.transponders = response.data;
		});
	}
	
	PageChanged()
	{
		this.eventsPromise = this.$http.post("/api/frontend/mypanel/events/" + this.currentPage + "/" + this.pageSize, this.filter)
		.then(response => {
			this.events = response.data;
			this.total = this.events.length > 0 ? this.events[0].total : 0;
		});
	}

	AddTransponder(form) 
	{
		if (!this.validation.checkFormValidity(form)) {
			// NOTE: Lo ideal seria mostrar el error solo despues del submit
			//this.msgError = this.$translate.instant("VALIDATION_ERROR");
			return;
		}

		var num = this.transponder;
		var desc = this.comments || "";
	
		if (num)
		{
			this.$http.post("/api/frontend/mypanel/transponderadd/" + num, {desc})
			.then(response =>
			{
				// TODO: evitar que despues de añadir nos de error de transponder vacio
				//this.validation.resetForm(form);
				
				this.transponder = null;
				this.comments = null;

				this.LoadTransponders();

				// TODO: Se podria a�adir el transponder del array directamente en vez de recargar
				//self.transponders.push({ transponder: num, comments: desc });
			});
		}
	}

	RemoveTransponder(data)
	{
		this.Modal.confirm.delete((/*Option params are passed here*/) => {
			this.$http.post("/api/frontend/mypanel/transponderremove/" + data.id)
			.then(response => {
				// TODO: Se podria borrar el transponder del array directamente en vez de recargar -> $scope.transponders.remove(data);
				this.LoadTransponders();
			});
		})({
			html: [
				"<strong>{{vm.transponder.num}} {{vm.transponder.desc}}</strong>",
				"{{'DIALOG_DeleteContent'|translate}}"],
			vm: {transponder: data}
		}/*Optional params here*/);
	}
}




// WEBPACK FOOTER //
// ./client/app/frontend/mypanel/mypanel.controller.js